
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"29","viewBox":"0 0 32 29","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.0789 0.145983C18.5965 -0.0925835 18.0195 -0.0375298 17.5939 0.274442L6.62134 8.25724H3.31067C1.48507 8.25724 0 9.69781 0 11.4687V16.9741C0 18.745 1.48507 20.1856 3.31067 20.1856H6.62134L17.5939 28.1683C17.8398 28.3519 18.1425 28.4436 18.4452 28.4436C18.6627 28.4436 18.8803 28.3977 19.0789 28.2968C19.5613 28.0674 19.864 27.5903 19.864 27.0673V1.37552C19.864 0.852506 19.5613 0.375373 19.0789 0.145983ZM2.83772 16.9741V11.4687C2.83772 11.2118 3.04582 11.0099 3.31067 11.0099H5.67544V17.4329H3.31067C3.04582 17.4329 2.83772 17.231 2.83772 16.9741ZM17.0263 24.3146L8.51315 18.121V10.3218L17.0263 4.1282V24.3146Z"}}),_c('path',{attrs:{"d":"M24.1671 10.1092C23.7464 9.58867 22.9834 9.5031 22.4558 9.9238C21.9352 10.3445 21.8497 11.1075 22.2704 11.6351C23.5253 13.3536 23.5253 15.6923 22.2704 17.4108C21.8497 17.9313 21.9281 18.7014 22.4486 19.1221C22.9692 19.5499 23.7392 19.4644 24.1599 18.9438L24.1671 18.9367C26.1565 16.327 26.1565 12.7118 24.1671 10.1092Z"}}),_c('path',{attrs:{"d":"M29.0372 6.45861C28.6165 5.93096 27.8465 5.85252 27.3259 6.27322C26.8054 6.69392 26.7198 7.45688 27.1405 7.98453C30.0426 11.8635 30.0426 17.1828 27.1405 21.0618C26.7127 21.5823 26.7983 22.3524 27.3188 22.7731C27.8393 23.2009 28.6094 23.1154 29.0301 22.5949L29.0372 22.5877C32.6096 17.8032 32.6096 11.236 29.0372 6.45861Z"}})])
          )
        }
      }
    